import { Card, Typography } from "antd";
import "./FeatureCard.scss";

const { Title, Text } = Typography;

export default function FeatureCard({ feature, index, token }) {
  return (
    <Card
      className="feature-card"
      hoverable
      style={{
        border: "none",
        backgroundColor: token?.Card?.colorBgCard,
        cursor: "default",
        borderTop: `3px solid ${
          index % 2 === 0 ? token?.colorPrimary : token?.colorSecondaryLogo
        }`,
      }}>
      <div className="feature-card__content" style={{ width: "100%" }}>
        <div
          className="feature-card__icon"
          style={{
            color:
              index % 2 === 0 ? token?.colorPrimary : token?.colorSecondaryLogo,
          }}>
          {feature?.icon}
        </div>
        <Title
          level={4}
          style={{
            color:
              index % 2 === 0 ? token?.colorPrimary : token?.colorSecondaryLogo,
            margin: 0,
          }}>
          {feature?.title}
        </Title>
        <Text className="feature-card__description">
          {feature?.description}
        </Text>
      </div>
    </Card>
  );
}
